import React, {useEffect, useRef} from "react";
import ReactDOM from "react-dom";
import SearchWithAiButton from "../SearchWithAiButton/SearchWithAiButton";

const ShopWithAiButtonInjector = ({
    merchantId,
    assistantConfiguration,
    brandTheme,
    onClick,
    log
}) => {
    const containerRef = useRef(null);

    useEffect(() => {
        if (!assistantConfiguration || !assistantConfiguration.shopWithAiButtonContainerSelector) {
            log && log("No search with AI button container selector provided in assistant configuration. Aborting ShopWithAiButtonInjector.");
            return;
        }

        // Find the container element using the provided selector
        const parentContainer = document.querySelector(assistantConfiguration.shopWithAiButtonContainerSelector);

        if (!parentContainer) {
            log && log(`Search with AI button container not found with selector: ${assistantConfiguration.shopWithAiButtonContainerSelector}`);
            return;
        }

        // Create a new container for the SearchWithAiButton component
        log && log("Creating button container");
        let buttonContainer = document.createElement("div");
        if (parentContainer.tagName === "UL" || parentContainer.tagName === "OL") {
            log && log("Creating list item for button container");
            buttonContainer = document.createElement("li");
        }

        parentContainer.appendChild(buttonContainer);
        containerRef.current = buttonContainer;

        // Render the SearchWithAiButton component into the container
        ReactDOM.render(
            <SearchWithAiButton
                merchantId={merchantId}
                assistantConfiguration={assistantConfiguration}
                brandTheme={brandTheme}
                onClick={onClick}
                buttonLabel="Shop With AI"
                log={log}
            />,
            buttonContainer
        );

        // Cleanup function: unmount and remove the container
        return () => {
            if (containerRef.current) {
                ReactDOM.unmountComponentAtNode(containerRef.current);
                containerRef.current.remove();
                containerRef.current = null;
            }
        };
    }, [assistantConfiguration, merchantId, brandTheme, onClick, log]);

    return null;
};

export default ShopWithAiButtonInjector;
